import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-937e92a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-methods" }
const _hoisted_2 = { class: "payment-methods-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "add_circle", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zahlungsmethode hinzufügen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_method = _resolveComponent("payment-method")!
  const _component_payment_method_loader = _resolveComponent("payment-method-loader")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_billing_add_payment_method_overlay = _resolveComponent("billing-add-payment-method-overlay")!
  const _component_md_overlay = _resolveComponent("md-overlay")!
  const _component_billing_delete_payment_method_modal = _resolveComponent("billing-delete-payment-method-modal")!
  const _component_billing_edit_payment_method_modal = _resolveComponent("billing-edit-payment-method-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.methods && _ctx.methods.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.methods, (method, index) => {
            return (_openBlock(), _createBlock(_component_payment_method, {
              method: method,
              key: index,
              onClickDelete: ($event: any) => (_ctx.openDeleteModal(method)),
              onClickEdit: ($event: any) => (_ctx.openEditModal(method))
            }, null, 8, ["method", "onClickDelete", "onClickEdit"]))
          }), 128))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(2, (n) => {
            return _createVNode(_component_payment_method_loader, { key: n })
          }), 64)),
      _createVNode(_component_md_card, {
        variant: "outlined",
        class: "add-payment-method",
        clickable: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addMethodVisible = true))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    false
      ? (_openBlock(), _createBlock(_component_empty_hint, {
          key: 0,
          title: "Noch keine Zahlungsmethoden hinzugefügt",
          description: "Füge eine Zahlungsmethode hinzu, um ein Abonnement abzuschließen."
        }, {
          default: _withCtx(() => [
            _createVNode(_component_md_button, {
              variant: "filled",
              icon: "add_circle",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addMethodVisible = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Zahlungsmethode hinzufügen")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_md_overlay, {
      title: "Zahlungsmethode hinzufügen",
      visible: _ctx.addMethodVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addMethodVisible) = $event)),
      loading: _ctx.addMethodLoading,
      image: _ctx.OverlayImage
    }, {
      default: _withCtx(() => [
        _createVNode(_component_billing_add_payment_method_overlay, {
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMethodVisible = false)),
          onLoading: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addMethodLoading = $event)),
          onComplete: _ctx.loadPaymentMethods
        }, null, 8, ["onComplete"])
      ]),
      _: 1
    }, 8, ["visible", "loading", "image"]),
    _createVNode(_component_billing_delete_payment_method_modal, {
      ref: "deleteMethodModal",
      method: _ctx.targetMethod
    }, null, 8, ["method"]),
    _createVNode(_component_billing_edit_payment_method_modal, {
      ref: "editMethodModal",
      method: _ctx.targetMethod
    }, null, 8, ["method"])
  ]))
}